import React from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

const Wrapper = styled.section`
  text-align: center;
  .container {
    padding-bottom: 100px;
    //border-bottom: 2px solid #cecece;
  }
`

const Background = styled.div`
  background-color: white;
  border-radius: 10px;
  box-shadow: 3px 3px 10px 0px #868080;
  padding: 30px 0;
`

const Title = styled.h4`
  font-size: 40px;
  font-weight: 900;
  margin-bottom: 20px;
  text-align: center;
  @media screen and (max-width: 599px) {
    font-size: 26px;
  }
`

const ButtonSee = styled.button`
  padding: 12px 60px;
  background-color: white;
  font-weight: 550;
  font-size: 20px;
  color: red;
  border: none;
  border-radius: 15px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  @media screen and (max-width: 599px) {
    padding: 12px 40px;
  }
`

const Ready: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <div className='container'>
        {/* <Background> */}
          {/* <Title>Ready to learn more?</Title> */}
          <ButtonSee onClick={() => navigate('/career')}>SEE MORE CAREER OPPORTUNITIES</ButtonSee>
        {/* </Background> */}
      </div>
    </Wrapper>
  )
}

export default Ready
